import { render, staticRenderFns } from "./CustomersForm.template.vue?vue&type=template&id=00dc7343&scoped=true&"
var script = {}
import style0 from "./CustomersForm.template.vue?vue&type=style&index=0&id=00dc7343&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc7343",
  null
  
)

export default component.exports